<template>
    <div class="movement-button "        
    >
        <v-btn 
        class="movement-btn midnightButton buttonBranding_midnight" 
        rounded
        @click="changeFocusMode"
        flat
        :ripple="false"
        >
            <span class="buttonText">Movement Focus</span>
            <!-- <v-icon class="icon" right>mdi-magnify</v-icon> -->
        </v-btn>
    </div>
    
</template>

<script> 
import store from '@/store';
//TODO : this isn't typescript
export default {
    name: 'MovementButton',
    data() {
        return {
            isMobile: window.innerWidth <= 900,
            
        };
    },
    mounted() {
        if (this.isMobile) {
            // this.searchMode = true;
        }
    },
    methods: {
     
        changeFocusMode() {
            
            store.dispatch('countryStoreData/setSelectedCountry', null).then(() => {
                store.dispatch('stateStoreData/setFocusMode', 'movement');
            })
            // store.dispatch('stateStoreData/setFocusMode', 'movement');
        }
    },
    computed:{
        focusMode(){
            return store.state.stateStoreData.focusMode;
        }
    }
}
</script>

<style scoped>

.movement-button {
    display: flex;
    justify-content: center;
    align-items: center;
    /* height: 100vh; */
    margin-top: -50px;
    position: absolute;
    top: 50%;
    right: 48px;
    padding: 0 0px 10px 0;
    letter-spacing: 0.48px;
}

.movement-btn {
    background-color: #333333; /* Adjust this color as needed */
    color: white;
    padding: 25px 24px;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    
    /* Font */

    font-family: 'GCO Sans' !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.8px;
    text-align: left;
    letter-spacing: 0.48px;

    text-transform: none;

    cursor: pointer;
}

.icon {
    font-size: 24px;
    margin-left: 10px;
    margin-right: -10px;
}

.movement-button .buttonText,
.movement-button .icon 
{
    margin-top: 3px !important;
}

/*media queries*/
/* mobile 900px */
@media (max-width: 900px) {
    .movement-button {
        /* position: absolute;
        top: 98.5%;
        bottom: 0px;
        right: 2%; */
        position: fixed;
        bottom: 42px;
        z-index: 10;
        height: 37px;
        display: block;
        top: inherit;
        right: 20px;
    }
}
</style>
